export * from './constants-generated';
export const CONFIG_ELEMENT_ID = 'basket-provider-data';
export const LOG_COLOR = '093';